const ITEMS = [
  "Marketing Strategy",
  "Brand Identity",
  "Performance Ads",
  "Data & Analytics",
  "Web & UI",
  "AI Automation",
  "Crypto / Web3",
  "Visual Design",
];

export default function Marquee() {
  const all = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee" aria-hidden="true" className="border-y border-white/[0.06] bg-black/30 overflow-hidden">
      <div className="ticker-track flex whitespace-nowrap py-6 gap-12">
        {all.map((label, i) => (
          <div key={i} className="flex items-center gap-12 text-[28px] lg:text-[34px] font-bold tracking-tight">
            <span className={i % 2 === 0 ? "text-white" : "text-white/35"}>
              {label}
            </span>
            <span className="text-[#C6F432]">✦</span>
          </div>
        ))}
      </div>
    </section>
  );
}
